<template>
  <v-app-bar
    app
  >
    <v-btn
      :ripple="false"
      v-show="storage.showBack"
      @click="prevHistory"
    >
      <v-icon
        start
        icon="west"
        class="font-30"
      ></v-icon>
    </v-btn>
    <v-btn
      :ripple="false"
      v-show="!storage.showBack"
    >
      <v-icon
        start
        icon="test"
        class="font-30"
      ></v-icon>
    </v-btn>
    <v-img
      :src="require('../assets/images/logo.png')"
      class="my-1"
      contain
      height="40"
      @click="setToRoute('home')"
    />
  </v-app-bar>
</template>

<script>
import { inject } from 'vue'

export default {
  name: 'PayHeader',
  setup () {
    const { prevHistory, setToRoute } = inject('history')
    const { storage } = inject('storage')

    return {
      storage,
      prevHistory,
      setToRoute
    }
  }
}
</script>
<style>
  .font-30 {
    font-size: 30px !important;
  }
  .font-40 i {
    font-size: 40px !important;
  }
  a.menu {
    color: black;
    text-decoration: none; /* no underline */
  }
</style>
